<template>
  <div
    class="file-icon-container"
    :class="size == 'small' ? 'small' : ''"
  >
    <img
      :class="['file-icon-content',iconClass]"
      src="@/assets/icons/PPT.svg"
    />
    <div class="file-type-name">
      {{ handlerHtmlName(type || getFileExtension(fileName)) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 1,2,3...
    fileState: {
      default: 0,
      type: Number,
    },
    // pdf,doc...
    fileType: {
      type: String,
      default: "",
    },
    // 全名
    fileName: {
      type: String,
      default: "",
    },
    // 大小
    size: {
      type: String,
      default: "",
    },
    htmlType: {
      type: String,
      default: "experiments",
    }
  },
  data() {
    return {
      type: "",
      state: "",
      iconClass: "",
      typeArr: [
        {
          type: ["docx", "doc"],
          state: 1,
          class: "word-icon",
        },
        {
          type: ["pptx", "ppt"],
          state: 2,
          class: "ppt-icon",
        },
        {
          type: ["pdf"],
          state: 3,
          class: "pdf-icon",
        },
        {
          type: ["mp4"],
          state: 4,
          class: "video-icon",
        },
        {
          type: ["mp3"],
          state: 5,
          class: "audio-icon",
        },
        {
          type: ["jpg", "png", "jpeg"],
          state: 6,
          class: "img-icon",
        },
        {
          type: ["xls", "xlsx"],
          state: 7,
          class: "xls-icon",
        },
        {
          type: ["html"],
          state: 8,
          class: "html-icon",
        },
      ],
    };
  },
  methods: {
    handlerHtmlName(type) {
      if(type === 'html') {
        if (this.htmlType === "experiments") {
          return "实验";
        } else if (this.htmlType === "materials") {
          return "资料";
        }
      }
      return type;
    },
    getFileExtension(filename) {
      if (filename === "") {
        return "";
      }
      const name = filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
      // console.log(name, "name");
      return name.toLowerCase();
    },
    async getType(type) {
      if (type) {
        type = type.toLowerCase();
      }
      if (this.fileType !== "") {
        this.type = this.fileType;
      }
      let obj = this.typeArr.find((item) => item.type.includes(type));
      if (obj) {
        this.state = obj.state;
        if(type === 'html') {
            if (this.htmlType === 'experiments') {
              this.iconClass = 'experiments-icon';
            } else if (this.htmlType === 'materials') {
              this.iconClass = 'materials-icon'
            }
        } else {
          
          this.iconClass = obj.class;
        }
      }
    },
  },
  watch: {
    fileType: {
      async handler(val) {
        if (val) {
          console.log('1')
          this.getType(val);
        }
      },
      immediate: true,
    },
    fileName: {
      handler(val) {
        if (val && val !== "") {
          this.type = this.getFileExtension(val);
          // console.log(this.type, "type");
          console.log('2')
          this.getType(this.type);
        }
      },
      immediate: true,
    },
    fileState: {
      handler(val) {
        if (val) {
          this.state = val;
          this.iconClass =
            this.typeArr.find((item) => item.state == val)?.class || {};
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang='less' scoped>
.video-icon {
  content: url("@/assets/icons/video-icon.svg");
}
.audio-icon {
  content: url("@/assets/icons/audio-icon.svg");
}
.word-icon {
  content: url("@/assets/icons/word-icon.svg");
}
.ppt-icon {
  content: url("@/assets/icons/PPT.svg");
}
.img-icon {
  content: url("@/assets/icons/image.svg");
}
.pdf-icon {
  content: url("@/assets/icons/img-icon.svg");
}
.xls-icon {
  content: url("@/assets/icons/PPT.svg");
}
.experiments-icon {
  content: url("@/assets/icons/html.svg");
}
.materials-icon {
  content: url("@/assets/icons/materials.svg");
}
.file-icon-container {
  position: relative;
  display: inline-block;
  .file-icon-content {
    width: 40px;
    height: 46px;
  }
  .file-type-name {
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    color: #ffffff;
    font-weight: bold;
    line-height: 1;
    white-space: nowrap;
  }
}
.small {
  .file-icon-content {
    width: 20px;
    height: 23px;
  }
  .file-type-name {
    font-size: 5px;
  }
}
</style>
